import SidebarShell from "@/components/SidebarShell/SidebarShell.vue";
import SidebarContext from "@/components/SidebarContext/SidebarContext.vue";
import SidebarUserFooter from "@/components/SidebarUserFooter/SidebarUserFooter.vue";
import brand_details from "@/data/brand_details";
import is_admin_user from "@/utils/auth_user";

// IMPORT UTILITIES
import { get_user_profile } from "@/router";

//Getting Company details
const details = brand_details();

export default {
  name: "PropertySidebar",

  components: {
    SidebarShell,
    SidebarContext,
    SidebarUserFooter
  },

  props: {
    active_property: {
      type: Object,
      required: true
    },
    properties: {
      type: Array,
      required: true
    },
    active_item: {
      type: String,
      default: "operations-overview"
    },
    can_view_portfolio: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return ({
      // MENU STATE
      active_menu_item: "operations-overview",
      dropdownOpen: false,

      //Sub Entity Details
      entity_name: details.sub_entity_name,
      entity_subtitle: details.sub_entity_subtitle,


      // FOOTER
      full_name: "Guest User",
      initials: "GU",
      is_admin: false,

      // BRAND LOGO
      bolide_short_logo: getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-logo")
        .replace(/['"]+/g, "")
    });
  },

  computed: {
    can_access_portfolio() {
      return this.is_admin || this.can_view_portfolio;
    },

    propertiesFormatted() {
      return (this.properties || []).map(item => ({
        id: item.id,
        label: item.title
      }));
    },

     menuItems() {
      return [
        { 
          key: "operations-overview", 
          label: "Real-Time Operations", 
          icon: "bi bi-pie-chart-fill" 
        },

        // --- UTILITIES (Now using Bolide Logo instead of an icon) ---
        { 
          key: "utilities", 
          label: "Utilities", 
          icon: "custom",
          logo: "https://empirewebvideos.s3.us-east-1.amazonaws.com/Probabase_bolide/short_bolide_logo.png"
        },

        // --- ENERGY ---
        { 
          key: "energy", 
          label: "Energy", 
          icon: "bi bi-lightning-charge-fill" 
        },

        // --- SAVINGS INSIGHTS ---
        { 
          key: "savings_insights", 
          label: "Savings Insights", 
          icon: "bi bi-cash-coin" 
        },
        // {
        //   key: "profit-share",
        //   label: "Profit Share",
        //   icon: "bi bi-percent",
        // },

        // --- SECURITY & CONNECTIVITY SPLIT ---
        { 
          key: "security", 
          label: "Security", 
          icon: "bi bi-shield-lock-fill" 
        },
        { 
          key: "connectivity", 
          label: "Connectivity", 
          icon: "bi bi-wifi" 
        },

        // --- INSIGHTS, RESOURCES, PARKING ---
        { 
          key: "insights-analytics", 
          label: "Insights & Analytics", 
          icon: "bi bi-graph-up-arrow" 
        },
        { 
          key: "resources", 
          label: "Resources", 
          icon: "bi bi-folder-fill" 
        },
        // { 
        //   key: "parking-access", 
        //   label: "Parking & Access", 
        //   icon: "bi bi-car-front-fill" 
        // }
      ];
    }
  },

  mounted() {
    this.load_user_name();
    // Auto-select operations-overview when PropertySidebar mounts
    this.active_menu_item = this.active_item;
  },

  watch: {
    active_item(newItem) {
      this.active_menu_item = newItem || "operations-overview";
    },

    active_property(newProperty) {
      // Auto-select operations-overview when active property changes
      if (newProperty) {
        if (this.active_item === "resources") {
          this.active_menu_item = this.active_item;
          return;
        }
        this.selectPropertyMenuItem('operations-overview');
      }
    }
  },

  methods: {
    /** FOOTER NAME INITIALS */
    load_user_name() {
      const user = get_user_profile();
      let name = "Guest User";
      this.is_admin = is_admin_user(user);

      if (user && (user.first_name || user.last_name)) {
        name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      } else {
        const first = sessionStorage.getItem("first_name") || "";
        const last = sessionStorage.getItem("last_name") || "";
        name = `${first} ${last}`.trim() || "Guest User";
      }

      if (name === "Guest User" && user?.email) {
        name = user.email.split("@")[0];
      }

      const parts = name.split(" ");
      const initials = ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "GU";

      this.full_name = name;
      this.initials = initials;
    },

    /** DROPDOWN LOGIC */
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    switchProperty(item) {
      this.dropdownOpen = false;

      this.$emit("switch-property", item.id);

      // reset to the first menu item
      this.active_menu_item = "operations-overview";
    },

    selectPropertyMenuItem(menuItem) {
      this.active_menu_item = menuItem;
      this.dropdownOpen = false;

      this.$emit("property-menu-selected", {
        menuItem,
        propertyId: this.active_property.id,
        propertyName: this.active_property.title
      });
    },

    backToGlobal() {
      if (!this.can_access_portfolio) {
        return;
      }

      this.dropdownOpen = false;
      this.$emit("go-back");
    },

  }
};
